import React from 'react';

// Automatically import all calculator components from the calculators folder
const calculatorModules = require.context('./calculators', true, /\.tsx$/);

// Build the component registry dynamically
const ComponentRegistry: { [key: string]: React.ComponentType<any> } = {};

calculatorModules.keys().forEach((fileName) => {
  // Get the component
  if (!fileName.startsWith('components/calculators/')) {

    const componentModule = calculatorModules(fileName);
    const component = componentModule.default || componentModule;
    // const component = componentModule;

    // Extract component name from file name (remove ./ and extension)
    const componentName = fileName.replace(/^\.\//, '').replace(/\.(jsx|tsx)$/, '');

    // Register by file name (e.g., "ModernSecurityCalculator")
    ComponentRegistry[componentName] = component;

    // Also register by formatted name with spaces (e.g., "Modern Security Calculator")
    const formattedName = componentName.replace(/([A-Z])/g, ' $1').trim();
    ComponentRegistry[formattedName] = component;
  }
});

// Manual mappings for custom calculator names (optional)
// Add specific mappings here if calculator names in DB don't match file names
// const customMappings: { [key: string]: string } = {
//   'Family Security Calculator': 'ModernSecurityCalculator',
//   'Living Value Visualization': 'LivingValueVisualization',
//   'Testing': 'Testing'
// };

// // Apply custom mappings
// Object.entries(customMappings).forEach(([customName, componentName]) => {
//   if (ComponentRegistry[componentName]) {
//     ComponentRegistry[customName] = ComponentRegistry[componentName];
//   }
// });

// Fallback component for unmapped calculators
const FallbackCalculator: React.FC<{ calculatorName: string }> = ({ calculatorName }) => {
  const availableComponents = Object.keys(ComponentRegistry).join(', ');

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-indigo-900 flex items-center justify-center p-8">
      <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-8 max-w-2xl text-center">
        <h2 className="text-2xl font-bold text-white mb-4">Calculator Not Found</h2>
        <p className="text-gray-300 mb-2">
          No component registered for: <strong className="text-cyan-400">{calculatorName}</strong>
        </p>
        <p className="text-gray-400 text-sm mb-4">
          Available calculators:
        </p>
        <pre className="text-left text-xs text-gray-300 bg-black/30 p-4 rounded overflow-auto max-h-40">
          {availableComponents}
        </pre>
      </div>
    </div>
  );
};

export const getComponent = (calculatorName: string): React.ComponentType<any> => {
  return ComponentRegistry[calculatorName] || FallbackCalculator;
};

export default ComponentRegistry;
